import { render, staticRenderFns } from "./AddProductSlot.vue?vue&type=template&id=ae1a9ecc"
import script from "./AddProductSlot.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddProductSlot.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AddProductSlot.vue?vue&type=style&index=0&id=ae1a9ecc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports